import { v4 as uuid } from 'uuid';
export function randomID() {
    return uuid();
}
